import { Button } from "primereact/button";
import { Growl } from "primereact/growl";
import React from "react";
import { Archivo } from '../componentes/Archivo';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { obtenerBytesBase64Archivos } from '../servicio/ServicioLecturaArchivos';
import servicioHttp from "../servicio/ServicioHttp";
import servicioObjetos from '../servicio/ServicioObjetos';
import { Message } from 'primereact/message';
export default class ImportarArchivoDeIncidencias extends React.Component {

    constructor() {
        super();
        this.state = {
            idsenube: 0,
            insidencia: {},
            listaErrores: [],
            errores: {},
            mensaje: null,
            duplicados: [],
            mostrarArchivos: true
        };
    }


    cargarArchivo = (event) => {
        obtenerBytesBase64Archivos(event, this);
    }

    importarArchivo = () => {
        let { insidencia } = this.state;
        const validacion = this.validarFormulario(insidencia);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            servicioHttp.consumirPostHttp('incidencia/procesar.json', insidencia).then(response => {
                console.log(response.data.objeto);

                this.setState({ listaErrores: response.data.objeto.datosArchivoSua, insidencia: {}, mensaje: response.data.mensaje, duplicados: response.data.objeto.datosDuplicados });
            }).catch(error => {

            });

        }
    }
    validarFormulario = (incidencia) => {
        const errores = {};
        if (servicioObjetos.esObjetoVacio(incidencia.archivo))
            errores.archivo = "Seleccione un archivo";

        return errores;
    }
    onIndexTemplate = (data, props) => {
        let { idsenube } = this.state;
        return (props.rowIndex + 1) + idsenube;
    }

    reiniciarPantalla = () => {
        this.setState({
            idsenube: 0,
            insidencia: {},
            listaErrores: [],
            errores: {},
            mensaje: null,
            duplicados: [],
            mostrarArchivos: false
        });
        setTimeout(() => {
            this.setState({ mostrarArchivos: true });
        }, 50);
    }

    render() {
        let { listaErrores, errores, mensaje, duplicados, mostrarArchivos } = this.state;

        let archivos =
            <div className="p-col-12 p-md-5">
                <Archivo id="insidencia" nombre="insidencia.archivo" etiqueta="Seleccionar archivo.txt" cambio={this.cargarArchivo} aceptar=".txt" />
                {errores.archivo ? <div><br /> <Message severity="error" text={errores.archivo} /> </div> : null}
            </div>;

        return (

            <div className="p-fluid">
                <Growl ref={(el) => this.growl = el} />
                <div className="p-grid">
                    <div className="p-col-12">
                        <div className="card card-w-wthite">
                            <center><h1>AUSENTISMOS E INCAPACIDAES</h1></center>

                            <div className="p-grid">
                                <div className="p-col-12 p-md-12">
                                    
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label></label>
                                </div>
                                <div className="p-col-12 p-md-5">
                                    <label>Importar archivos con coincidencias</label>
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label>Archivo:</label>
                                </div>
                                {/* <div className="p-col-12 p-md-5">
                                    <Archivo id="insidencia" nombre="insidencia.archivo" etiqueta="Seleccionar archivo.txt" cambio={this.cargarArchivo} aceptar=".txt" />
                                    {errores.archivo ? <div><br /> <Message severity="error" text={errores.archivo} /> </div> : null}
                                </div> */}
                                {mostrarArchivos ? archivos : null}


                                <div className="p-col-12 p-md-1">
                                    <label></label>
                                </div>
                                <div className="p-col-12 p-md-2">

                                </div>
                                <div className="p-col-12 p-md-12">
                                    
                                </div>
                                <div className="p-col-12 p-md-3">
                                    <Button label="Importar archivo" icon="pi-md-import-export" showIcon={true} onClick={this.importarArchivo} />
                                </div>
                                <div className="p-col-12 p-md-12">
                                    
                                </div>
                                <div className="p-col-12 p-md-12">
                                    <h1>{mensaje}</h1>
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <DataTable value={listaErrores} header="ERRORES AL IMPORTAR ARCHIVO" scrollable responsive={true}>
                                        <Column field="Index" header="NO." body={this.onIndexTemplate} style={{ width: '30px' }} autoLayout={true} />
                                        <Column field="numeroLinea" header="RENGLON" style={{ width: '60px' }} autoLayout={true} />
                                        <Column field="columna" header="COLUMNA" style={{ width: '60px' }} autoLayout={true} />
                                        <Column field="longitud" header="LONGITUD" style={{ width: '60px' }} autoLayout={true} />
                                        <Column field="descipcion" header="DESCRIPCION" style={{ width: '200px' }} autoLayout={true} />
                                    </DataTable>
                                </div>

                                <div className="p-col-12 p-md-12">
                                    
                                </div>
                                <div className="p-col-12 p-md-12">
                                    
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <DataTable value={duplicados} header="REGISTROS DUPLICADOS" scrollable responsive={true}>
                                        <Column field="Index" header="NO." body={this.onIndexTemplate} style={{ width: '30px' }} autoLayout={true} />
                                        <Column field="registroPatronal" header="REGISTRO PATRONAL" style={{ width: '180px' }} autoLayout={true} />
                                        <Column field="nss" header="NSS" style={{ width: '200px' }} autoLayout={true} />
                                    </DataTable>
                                </div>

                                <div className="p-col-12 p-md-12">
                                    <label></label>
                                </div>
                                <div className="p-col-12 p-md-9">
                                    
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <Button label="Continuar" onClick={this.reiniciarPantalla} icon="pi-md-refresh" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}